import { useState, useEffect } from 'react';
import * as Sentry from 'shared/domains/sentry';
import { validateEditorBundleVersion } from './validateEditorBundleVersion';
const initialState = { loading: true, valid: undefined, error: undefined };
/**
 * Hook to validate editor bundle version with current bundle version.
 * Re-runs whenever `documentId` changes, so every document opened - including via
 * client-side navigation between documents - gets its own check.
 * Treats a failed check (network error, bad response) the same as a mismatch: fail
 * closed rather than letting an unverified editor bundle load.
 */
export function useEditorVersionManifest(documentId) {
    const [state, setState] = useState(initialState);
    useEffect(() => {
        const controller = new AbortController();
        setState(initialState);
        validateEditorBundleVersion(controller.signal)
            .then((data) => {
            setState({ loading: false, valid: data, error: undefined });
        })
            .catch((error) => {
            if (controller.signal.aborted) {
                return;
            }
            Sentry.captureException(error, { tags: { feature: 'pleditor-version-check' } });
            setState({ loading: false, valid: false, error });
        });
        return () => {
            controller.abort();
        };
    }, [documentId]);
    return state;
}
